import React from 'react';
import { useTranslation } from 'react-i18next';
import LimitedInput from '@src/new-components/Input/LimitedInput';

export const OTHER_TEXT_MAX_LENGTH = 500;

const OtherTextArea = ({ value = '', onChange }) => {
  const { t } = useTranslation();

  const handleChange = (event) => onChange(event.target.value);

  return (
    <div className="survey-other">
      <LimitedInput
        multiline
        rows={3}
        maxLength={OTHER_TEXT_MAX_LENGTH}
        value={value}
        placeholder={t('enterOwnAnswer')}
        onChange={handleChange}
        inputProps={{ maxLength: OTHER_TEXT_MAX_LENGTH }}
      />
    </div>
  );
};

export default OtherTextArea;
